import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import logger from '@nerdwallet/home-app-lib/logger';
import axiosHomeownership from '../axios-homeownership';
import { RECEIVE_RATES } from '../../reducers/actions';
/**
 * Action creator to fetch rates from the service.
 *
 * @param callback
 * @returns {Function} The callback to the action creator.
 *
 * @private
 */

export default function fetchHistoricalRates() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      state = _ref.state;

  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var _yield$axiosHomeowner, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return axiosHomeownership({
                url: '/v3/mortgage-rates/historical',
                method: 'POST',
                data: {
                  state: state
                }
              });

            case 3:
              _yield$axiosHomeowner = _context.sent;
              data = _yield$axiosHomeowner.data;
              dispatch({
                type: RECEIVE_RATES,
                data: data
              });
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              logger.error('fetchHistoricalRates', _context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}